var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgFinalAssigComp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.359,
    height: 22.293,
    viewBox: "0 0 21.359 22.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task-complete-svgrepo-com",
    transform: "translate(-0.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_22_",
    transform: "translate(0.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M3.421,18.271V2.436H16.209v13.3l2.437-2.013V1.218A1.218,1.218,0,0,0,17.428,0H2.2A1.218,1.218,0,0,0,.985,1.218v18.27A1.218,1.218,0,0,0,2.2,20.707H12.831l-1.722-2.436Z",
    transform: "translate(-0.985)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M33.381,27.425a.609.609,0,0,0-.805-.027l-5.587,4.617-3.723-2.234a.609.609,0,0,0-.811.874l4.035,5.709a.61.61,0,0,0,.492.258h.006a.607.607,0,0,0,.491-.249l5.976-8.146A.61.61,0,0,0,33.381,27.425Z",
    transform: "translate(-12.212 -14.329)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M17.856,8.988H10.548a1.218,1.218,0,0,0,0,2.436h7.308a1.218,1.218,0,0,0,0-2.436Z",
    transform: "translate(-5.372 -4.725)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M17.856,16.691H10.548a1.218,1.218,0,0,0,0,2.436h7.308a1.218,1.218,0,0,0,0-2.436Z",
    transform: "translate(-5.372 -8.774)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M17.856,24.4H10.548a1.218,1.218,0,0,0,0,2.436h7.308a1.218,1.218,0,0,0,0-2.436Z",
    transform: "translate(-5.372 -12.824)",
    fill: "#136ad0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgFinalAssigComp);
export default __webpack_public_path__ + "static/media/avg-final-assig-comp.12901c263462999935273886ec267f37.svg";
export { ForwardRef as ReactComponent };